// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3wLSy","title":"BackImages_title__1V-Ke","images":"BackImages_images__1VWE9"};